import * as React from 'react';


export interface Option {
  label: string;
  // TODO: Proper event type
  onClick: (e: any) => any;
};


export default (props) => {
  const { onClick, label, options } = props;

  return (
    <div className="drop__cont">
      <a onClick={onClick} href="javascript:void(null)" className="btn btn--prim btn--md drop__anch">
        {label} <span className="i i-tri-b"></span>
      </a>

      <div className="drop__inn">
        {options.map((opt) => (
          <a key={opt.label} href="javascript:void(null)" onClick={opt.onClick}>{opt.label}</a>
        ))}
      </div>
    </div>
  );
};
